/**
 * 认证 API：登录、注册、邮箱验证码、刷新 token 等
 */

/** 获取邮箱验证码（走 Next.js rewrite 代理，不带 /api 前缀） */
export async function getEmailCode(type, email) {
    const params = new URLSearchParams({ type, email });
    const res = await fetch(`/auth/email-code?${params}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    const json = await res.json();
    if (json && typeof json === 'object' && 'code' in json) {
        const ok = json.code === 200 || json.code === 0;
        return ok ? { success: true, data: json.data } : { success: false, error: json.message || '请求失败' };
    }
    return { success: true, data: json };
}

/**
 * 邮箱密码登录
 * POST /auth/login
 * body: { email, password, loginType: "password" }
 */
export async function loginByEmail(email, password) {
    const res = await fetch(`/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, loginType: 'password' }),
    });
    const json = await res.json();
    if (json && typeof json === 'object' && 'code' in json) {
        const ok = json.code === 200 || json.code === 0;
        return ok
            ? { success: true, data: json.data }
            : { success: false, error: json.message || '登录失败' };
    }
    return { success: true, data: json };
}

/**
 * 手机号密码登录
 * POST /auth/login
 * body: { phone, password, loginType: "password" }
 * @param {string} fullPhone 完整手机号（已含 +224 前缀）
 */
export async function loginByPhone(fullPhone, password) {
    const res = await fetch(`/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: fullPhone, password, loginType: 'password' }),
    });
    const json = await res.json();
    if (json && typeof json === 'object' && 'code' in json) {
        const ok = json.code === 200 || json.code === 0;
        return ok
            ? { success: true, data: json.data }
            : { success: false, error: json.message || '登录失败' };
    }
    return { success: true, data: json };
}

/** 用户注册（走 Next.js rewrite 代理，不带 /api 前缀，JSON body） */
export async function register(payload) {
    const res = await fetch(`/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    const json = await res.json();
    if (json && typeof json === 'object' && 'code' in json) {
        const ok = json.code === 200 || json.code === 0;
        return ok ? { success: true, data: json.data } : { success: false, error: json.message || '请求失败' };
    }
    return { success: true, data: json };
}

/**
 * 发送邮箱验证码（供忘记密码页面调用）
 * POST /auth/email-code?type={type}&email={email}
 * Content-Type: application/x-www-form-urlencoded
 */
export async function sendEmailCode(email, type) {
    const params = new URLSearchParams({ type, email });
    const res = await fetch(`/auth/email-code?${params}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    const json = await res.json();
    if (json && typeof json === 'object' && 'code' in json) {
        const ok = json.code === 200 || json.code === 0;
        return ok ? { success: true, data: json.data } : { success: false, error: json.message || '请求失败' };
    }
    return { success: true, data: json };
}

/**
 * 重置密码
 * POST /auth/reset-password
 * body: { email, code, newPassword }
 */
export async function resetPassword({ email, code, newPassword }) {
    const res = await fetch(`/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code, newPassword }),
    });
    const json = await res.json();
    if (json && typeof json === 'object' && 'code' in json) {
        const ok = json.code === 200 || json.code === 0;
        return ok
            ? { success: true, data: json.data }
            : { success: false, error: json.message || '重置密码失败' };
    }
    return { success: true, data: json };
}

/** 获取 Facebook 授权地址 */
export async function getFacebookAuthUrl() {
    const res = await fetch(`/auth/facebook/url`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
    });
    const json = await res.json();
    if (json && typeof json === 'object' && 'code' in json) {
        const ok = json.code === 200 || json.code === 0;
        return ok ? { success: true, data: json.data } : { success: false, error: json.message || '获取 Facebook 授权地址失败' };
    }
    return { success: true, data: json };
}

/** Facebook 登录回调：提交 code 和 state，换取站内登录态 */
export async function loginWithFacebook(code, state) {
    const res = await fetch(`/auth/facebook/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ code, state }),
    });
    const json = await res.json();
    if (json && typeof json === 'object' && 'code' in json) {
        const ok = json.code === 200 || json.code === 0;
        return ok ? { success: true, data: json.data } : { success: false, error: json.message || 'Facebook 登录失败' };
    }
    return { success: true, data: json };
}

export const authApi = {
    emailCode: getEmailCode,
    sendEmailCode,
    loginByEmail,
    loginByPhone,
    register,
    resetPassword,
    getFacebookAuthUrl,
    loginWithFacebook,
};
